import { ref, reactive } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import axiosIns from "@/libs/axios";

export default function useExtraPaymentCategories(ctx) {
  const toast = useToast();

  const loading = ref(false);
  const categories = ref([]);
  const selectedCategory = ref(null);

  const isEditMode = ref(false);
  const extraPaymentForm = ref(null);

  const tableColumns = [
    {
      key: "name",
      label: "Name",
    },
    {
      key: "benefit_en",
      label: "Benefit En",
    },
    {
      key: "benefit_ar",
      label: "Benefit Ar",
    },
    {
      key: "group_segment_name",
      label: "Group Segment",
    },
    {
      key: "code",
      label: "Code",
    },
    {
      key: "amount",
      label: "Amount",
    },
    {
      key: "actions",
      label: "Actions",
      thClass: "text-center",
      tdClass: "text-center",
    },
  ];

  const queryParams = reactive({
    name: "",
    group_segment_name: "",
  });

  const fetchCategories = async () => {
    try {
      loading.value = true;
      const response = await axiosIns.get("/bills/extra/categories");

      if (response.data) {
        categories.value = response.data.data || response.data;
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      toast.error("Failed to fetch categories");
      categories.value = [];
    } finally {
      loading.value = false;
    }
  };

  const openDeleteModal = (category) => {
    selectedCategory.value = category;
    ctx.root.$bvModal.show("delete-extra-payment-modal");
  };

  fetchCategories();

  const openModal = () => {
    if (extraPaymentForm.value) {
      extraPaymentForm.value.openModal();
    }
  };

  const openEditModal = (category) => {
    isEditMode.value = true;
    selectedCategory.value = category;
    extraPaymentForm.value.openModal();
  };
  return {
    openEditModal,
    isEditMode,
    extraPaymentForm,
    openModal,
    tableColumns,
    loading,
    categories,
    selectedCategory,
    queryParams,
    fetchCategories,
    openDeleteModal,
  };
}
